// reducers.js
import { createSlice } from "@reduxjs/toolkit";

const langSlice = createSlice({
  name: "lang",
  initialState: { value: "" },
  reducers: {
    setLang: (state, action) => {
      state.value = action.payload;
    },
  },
});

const eFabricaSlice = createSlice({
  name: "eFabrica",
  initialState: [],
  reducers: {
    setEFabrica: (state, action) => {
      return action.payload;
    },
  },
});

const userTypeSlice = createSlice({
  name: "userType",
  initialState: { value: "" },
  reducers: {
    setUserType: (state, action) => {
      state.value = action.payload;
    },
  },
});

const userSlice = createSlice({
  name: "user",
  initialState: {
    name: "",
    team: "",
    cod_team: "",
    nivel_acceso: "",
  },
  reducers: {
    setName: (state, action) => {
      state.name = action.payload;
    },
    setTeam: (state, action) => {
      state.team = action.payload;
    },
    setCodTeam: (state, action) => {
      state.cod_team = action.payload;
    },
    setNivelAcceso: (state, action) => {
      state.nivel_acceso = action.payload;
    },
  },
});

const infoDataSlice = createSlice({
  name: "infoData",
  initialState: {
    infoData: null,
  },
  reducers: {
    updateInfoData: (state, action) => {
      state.infoData = action.payload;
    },
  },
});

const timerSlice = createSlice({
  name: "timer",
  initialState: {
    isTimerRunning: false,
  },
  reducers: {
    setTimerRunning: (state, action) => {
      state.isTimerRunning = action.payload;
    },
  },
});

const listMetalsSlice = createSlice({
  name: "listMetals",
  initialState: [],
  reducers: {
    setListMetals: (state, action) => {
      return action.payload;
    },
  },
});

const groupListSlice = createSlice({
  name: "groupList",
  initialState: [],
  reducers: {
    setGroupList: (state, action) => {
      return action.payload;
    },
  },
});

const groupFinishListSlice = createSlice({
  name: "groupFinishList",
  initialState: [],
  reducers: {
    setGroupFinishList: (state, action) => {
      return action.payload;
    },
  },
});

const listAleacionOptionSlice = createSlice({
  name: "listAleacionOption",
  initialState: [],
  reducers: {
    setListAleacionOption: (state, action) => {
      return action.payload;
    },
  },
});

const incidenceCounterSlice = createSlice({
  name: "incidenceCounter",
  initialState: { value: "" },
  reducers: {
    setIncidenceCounter: (state, action) => {
      state.value = action.payload;
    },
  },
});

const cantidadSlice = createSlice({
  name: "cantidad",
  initialState: {
    cantidadData: null,
    totalCantidad: null,
  },
  reducers: {
    updateCantidadData: (state, action) => {
      state.cantidadData = action.payload;
    },
    setTotalCantidad: (state, action) => {
      state.totalCantidad = action.payload;
    },
  },
});

const updateDataTableWeightSlice = createSlice({
  name: "pesosList",
  initialState: {
    listaPesos: [],
  },
  reducers: {
    updateListaPesos: (state, action) => {
      state.listaPesos = action.payload;
    },
  },
});

const authQualityUsersSlice = createSlice({
  name: "authQualityUsers",
  initialState: [],
  reducers: {
    setAuthQualityUsers: (state, action) => {
      return action.payload;
    },
  },
});

const calendarioSlice = createSlice({
  name: "calendario",
  initialState: [],
  reducers: {
    setCalendario: (state, action) => {
      return action.payload;
    },
  },
});

export const { setLang } = langSlice.actions;
export const { setUserType } = userTypeSlice.actions;
export const { setName, setTeam, setCodTeam, setNivelAcceso } =
  userSlice.actions;
export const { updateInfoData } = infoDataSlice.actions;
export const { setTimerRunning } = timerSlice.actions;
export const { setListMetals } = listMetalsSlice.actions;
export const { setGroupList } = groupListSlice.actions;
export const { setGroupFinishList } = groupFinishListSlice.actions;
export const { setListAleacionOption } = listAleacionOptionSlice.actions;
export const { setIncidenceCounter } = incidenceCounterSlice.actions;
export const { updateCantidadData, setTotalCantidad } = cantidadSlice.actions;
export const { updateListaPesos } = updateDataTableWeightSlice.actions;
export const { setEFabrica } = eFabricaSlice.actions;
export const { setAuthQualityUsers } = authQualityUsersSlice.actions;
export const { setCalendario } = calendarioSlice.actions;

export const incidentCount = incidenceCounterSlice.reducer;
export const langReducer = langSlice.reducer;
export const dataUser = userSlice.reducer;
export const userTypeReducer = userTypeSlice.reducer;
export const infoDataReducer = infoDataSlice.reducer;
export const timerReducer = timerSlice.reducer;
export const listMetalsReducer = listMetalsSlice.reducer;
export const groupListReducer = groupListSlice.reducer;
export const groupFinishListReducer = groupFinishListSlice.reducer;
export const listAleacionOptionReducer = listAleacionOptionSlice.reducer;
export const cantidadReducer = cantidadSlice.reducer;
export const pesosReducer = updateDataTableWeightSlice.reducer;
export const eFabricaReducer = eFabricaSlice.reducer;
export const authQualityUsersReducer = authQualityUsersSlice.reducer;
export const calendarioReducer = calendarioSlice.reducer;
